<template>
  <ProductDescriptionDrawerBase
    :title="$t('product.description.fabricksAuthentication')"
  >
    <template #content>
      <div class="flex flex-col">
        <ProductDescriptionFabricksLogo
          class="object-contain max-h-14 flex self-center mt-4 mb-8"
        />
        <span class="text-platform-text-2">
          {{ $t("product.description.fabricksAuthenticationDescription") }}
        </span>
        <I18nT
          scope="global"
          keypath="product.description.website"
          tag="p"
          class="text-platform-text-2 mt-1"
        >
          <template #link>
            <a
              href="/authenticate"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ $t("product.description.websiteLink") }}
            </a>
          </template>
        </I18nT>
      </div>
    </template>
  </ProductDescriptionDrawerBase>
</template>
